import { nextTick, provide, ref } from "vue";
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
export default {
  setup() {
    const isRouter = ref(true);

    const reload = () => {
      isRouter.value = false;
      nextTick(() => {
        isRouter.value = true;
      });
    };

    provide("reload", reload);
    return {
      isRouter,
      reload,
      locale: zhCn
    };
  }

};